/* Rider Shop — interacciones del tema (sin dependencias) */
(() => {
  'use strict';

  const theme = window.theme || { routes: {} };
  const routes = theme.routes || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const CLOSE_SVG =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  /* ---------- Dinero (respeta el formato de la tienda) ---------- */
  function formatMoney(cents, format) {
    const fmt = format || theme.moneyFormat || '${{amount}}';
    const value = Number(cents) || 0;
    const build = (precision, thousands = ',', decimal = '.') => {
      const [int, dec] = (value / 100).toFixed(precision).split('.');
      const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return dec ? grouped + decimal + dec : grouped;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return build(0);
        case 'amount_with_comma_separator': return build(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return build(0, '.', ',');
        case 'amount_with_apostrophe_separator': return build(2, "'", '.');
        case 'amount_with_space_separator': return build(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return build(0, ' ', ',');
        default: return build(2);
      }
    });
  }

  /* ---------- Notificaciones ---------- */
  function toast(message, tone = 'info') {
    const host = $('[data-toasts]');
    if (!host || !message) return;
    const el = document.createElement('div');
    el.className = 'toast' + (tone === 'error' ? ' toast--error' : '');
    el.setAttribute('role', tone === 'error' ? 'alert' : 'status');
    el.innerHTML = '<p></p><button type="button" aria-label="Cerrar notificación">' + CLOSE_SVG + '</button>';
    el.querySelector('p').textContent = message;
    const remove = () => el.remove();
    el.querySelector('button').addEventListener('click', remove);
    host.appendChild(el);
    while (host.children.length > 3) host.firstElementChild.remove();
    setTimeout(remove, tone === 'error' ? 6500 : 4000);
  }

  /* ---------- Paneles (<dialog>) ---------- */
  function openDrawer(id) {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (!dialog.open) dialog.showModal();
    if (id === 'SearchPanel') {
      const input = $('[data-search-input]', dialog);
      requestAnimationFrame(() => input && input.focus());
    }
    return true;
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open-drawer]');
    if (opener) {
      if (openDrawer(opener.dataset.openDrawer)) event.preventDefault();
      return;
    }
    const closer = event.target.closest('[data-close-drawer]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
      return;
    }
    // Clic en el fondo oscuro
    if (event.target instanceof HTMLDialogElement && /\b(drawer|welcome|review-viewer)\b/.test(event.target.className)) {
      event.target.close();
    }
  });

  // Atajo "/" para buscar
  document.addEventListener('keydown', (event) => {
    if (event.key !== '/' || event.metaKey || event.ctrlKey) return;
    const t = event.target;
    if (t && (/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName) || t.isContentEditable)) return;
    if (openDrawer('SearchPanel')) event.preventDefault();
  });

  /* ---------- Carrito (Ajax API + Section Rendering API) ---------- */
  function cartSectionIds() {
    const ids = ['cart-drawer', 'cart-icon-bubble'];
    const page = $('[data-cart-page]');
    if (page && page.dataset.sectionId) ids.push(page.dataset.sectionId);
    return ids;
  }

  function renderCartSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const fresh = $('[data-cart-drawer-content]', parseHTML(sections['cart-drawer']));
      const current = $('[data-cart-drawer-content]');
      if (fresh && current) current.replaceWith(fresh);
    }
    if (sections['cart-icon-bubble']) {
      const doc = parseHTML(sections['cart-icon-bubble']);
      const source = $('.shopify-section', doc) || doc.body;
      const target = $('#CartCount');
      if (target) target.innerHTML = source.innerHTML;
    }
    const page = $('[data-cart-page]');
    if (page && sections[page.dataset.sectionId]) {
      const fresh = $('[data-cart-page]', parseHTML(sections[page.dataset.sectionId]));
      if (fresh) page.replaceWith(fresh);
    }
  }

  function bumpCartCount() {
    const badge = $('#CartCount .cart-count');
    if (!badge) return;
    badge.classList.remove('is-bumped');
    void badge.offsetWidth;
    badge.classList.add('is-bumped');
  }

  async function addToCart(items) {
    const res = await fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: cartSectionIds().join(','), sections_url: window.location.pathname }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(data.description || data.message || 'No pudimos agregar el producto. Intentá de nuevo.');
    }
    renderCartSections(data.sections);
    bumpCartCount();
    if (!$('[data-cart-page]')) openDrawer('CartDrawer');
    return data;
  }

  async function changeLine(key, quantity) {
    const res = await fetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity, sections: cartSectionIds(), sections_url: window.location.pathname }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'No pudimos actualizar el carrito.');
    renderCartSections(data.sections);
    return data;
  }

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-cart-qty]');
    if (!btn) return;
    event.preventDefault();
    const line = btn.closest('[data-cart-line]');
    if (!line || line.classList.contains('is-loading')) return;
    line.classList.add('is-loading');
    try {
      await changeLine(line.dataset.cartLine, Math.max(0, Number(btn.dataset.cartQty) || 0));
    } catch (error) {
      toast(error.message, 'error');
      line.classList.remove('is-loading');
    }
  });

  /* ---------- Agregar rápido desde tarjetas ---------- */
  document.addEventListener('click', async (event) => {
    const openPicker = event.target.closest('[data-quick-picker-open]');
    if (openPicker) {
      const picker = openPicker.closest('[data-quick-picker]');
      const panel = $('[data-quick-picker-panel]', picker);
      openPicker.hidden = true;
      openPicker.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      const first = $('.size-btn:not(:disabled)', panel);
      if (first) first.focus();
      return;
    }
    const closePicker = event.target.closest('[data-quick-picker-close]');
    if (closePicker) {
      const picker = closePicker.closest('[data-quick-picker]');
      $('[data-quick-picker-panel]', picker).hidden = true;
      const trigger = $('[data-quick-picker-open]', picker);
      trigger.hidden = false;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
      return;
    }
    const quick = event.target.closest('[data-quick-add]');
    if (!quick || quick.disabled) return;
    event.preventDefault();
    const label = quick.textContent;
    quick.disabled = true;
    quick.classList.add('is-loading');
    if (!quick.classList.contains('size-btn')) quick.textContent = 'Agregando…';
    try {
      await addToCart([{ id: Number(quick.dataset.quickAdd), quantity: 1 }]);
      const picker = quick.closest('[data-quick-picker]');
      if (picker) {
        $('[data-quick-picker-panel]', picker).hidden = true;
        $('[data-quick-picker-open]', picker).hidden = false;
      }
    } catch (error) {
      toast(error.message, 'error');
    } finally {
      quick.disabled = false;
      quick.classList.remove('is-loading');
      if (!quick.classList.contains('size-btn')) quick.textContent = label;
    }
  });

  /* ---------- Galería ---------- */
  function initGallery(root) {
    const track = $('[data-gallery-track]', root);
    if (!track) return null;
    const slides = $$('.gallery__slide', track);
    const thumbs = $$('[data-gallery-thumb]', root);
    const dots = $$('[data-gallery-dot]', root);
    const counter = $('[data-gallery-index]', root);
    const prev = $('[data-gallery-prev]', root);
    const next = $('[data-gallery-next]', root);
    let index = 0;

    const goTo = (i, smooth = true) => {
      const target = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: track.clientWidth * target, behavior: smooth && !reducedMotion() ? 'smooth' : 'auto' });
    };
    const sync = () => {
      index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      if (counter) counter.textContent = String(index + 1);
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    };
    let frame = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(sync);
    }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.galleryThumb))));
    if (prev) prev.addEventListener('click', () => goTo(index - 1));
    if (next) next.addEventListener('click', () => goTo(index + 1));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') goTo(index + 1);
      if (e.key === 'ArrowLeft') goTo(index - 1);
    });
    sync();

    return {
      showMedia(mediaId) {
        const i = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
        if (i >= 0) goTo(i);
      },
    };
  }

  /* ---------- Ficha de producto ---------- */
  function initProduct(root) {
    const jsonEl = $('[data-product-json]', root);
    const form = $('[data-product-form]', root);
    if (!jsonEl || !form) return;
    const product = JSON.parse(jsonEl.textContent);
    let stock = {};
    try { stock = JSON.parse($('[data-variant-stock]', root).textContent); } catch (_) { /* opcional */ }

    const gallery = initGallery($('[data-gallery]', root) || root);
    rememberProduct(product.handle);
    initLightbox(root, gallery);
    const fieldsets = $$('[data-option]', root);
    const idInput = $('[data-variant-input]', form);
    const addBtn = $('[data-add-button]', form);
    const addLabel = $('[data-add-label]', form);
    const errorBox = $('[data-buy-error]', form);
    const dynamic = $('[data-dynamic-checkout]', form);
    const qtyInput = $('input[name="quantity"]', form);
    const sticky = $('[data-sticky-buy]', root);
    const stickyBtn = $('[data-sticky-add]', root);
    const stickyPrice = $('[data-sticky-price]', root);

    const selection = () => fieldsets.map((fs) => {
      const checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });
    const find = (sel) => product.variants.find((v) => v.options.every((o, i) => o === sel[i]));
    let current = product.variants.find((v) => String(v.id) === idInput.value) || product.variants[0];

    const updateOptionStates = (sel) => {
      fieldsets.forEach((fs, i) => {
        $$('input', fs).forEach((input) => {
          const candidate = sel.slice();
          candidate[i] = input.value;
          const match = find(candidate);
          let state;
          if (match) state = match.available ? 'available' : 'soldout';
          else {
            const withValue = product.variants.filter((v) => v.options[i] === input.value);
            state = !withValue.length ? 'unavailable' : withValue.some((v) => v.available) ? 'available' : 'soldout';
          }
          input.classList.toggle('is-soldout', state === 'soldout');
          input.classList.toggle('is-unavailable', state === 'unavailable');
        });
        const label = $('[data-option-label]', fs);
        if (label) label.textContent = sel[i] || '';
      });
    };

    const render = (variant) => {
      const priceBox = $('[data-price]', root);
      const available = Boolean(variant && variant.available);
      root.classList.toggle('product--soldout', !available);
      if (variant) {
        idInput.value = variant.id;
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        $('[data-price-current]', priceBox).textContent = formatMoney(variant.price);
        const compare = $('[data-price-compare]', priceBox);
        compare.hidden = !onSale;
        if (onSale) $('[data-price-compare-value]', compare).textContent = formatMoney(variant.compare_at_price);
        priceBox.classList.toggle('price--sale', Boolean(onSale));
        const save = $('[data-save]', root);
        if (save) {
          save.hidden = !onSale;
          if (onSale) $('[data-save-amount]', save).textContent = formatMoney(variant.compare_at_price - variant.price);
        }
        const badge = $('[data-gallery-badge]', root);
        if (badge) {
          const pct = onSale ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) : 0;
          badge.hidden = !(pct > 0 && available);
          badge.textContent = '-' + pct + '%';
        }
        const sku = $('[data-sku]', root);
        if (sku) {
          sku.hidden = !variant.sku;
          $('[data-sku-value]', sku).textContent = variant.sku || '';
        }
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        if (variant.featured_media && gallery) gallery.showMedia(variant.featured_media.id);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(window.history.state, '', url.toString());
      }

      const state = variant ? stock[variant.id] || (available ? 'instock' : 'soldout') : 'soldout';
      const stockEl = $('[data-stock]', root);
      if (stockEl) {
        stockEl.className = 'stock stock--' + (variant ? state : 'soldout');
        $('[data-stock-label]', stockEl).textContent = !variant
          ? 'Combinación no disponible'
          : state === 'soldout' ? 'Agotado' : state === 'backorder' ? 'Por encargue' : 'En stock';
      }
      addBtn.disabled = !available;
      addLabel.textContent = available ? 'Agregar al carrito' : variant ? 'Agotado' : 'Elegí otra combinación';
      if (dynamic) dynamic.hidden = !available;
      if (stickyBtn) {
        stickyBtn.disabled = !available;
        stickyBtn.textContent = available ? 'Agregar' : 'Agotado';
      }
      if (errorBox) errorBox.hidden = true;
    };

    fieldsets.forEach((fs, i) => {
      fs.addEventListener('change', (event) => {
        const input = event.target;
        let sel = selection();
        if (!find(sel)) {
          // La combinación no existe: se salta a la mejor variante con ese valor.
          const fallback =
            product.variants.find((v) => v.options[i] === input.value && v.available) ||
            product.variants.find((v) => v.options[i] === input.value);
          if (fallback) {
            fieldsets.forEach((f, j) => {
              const radio = $$('input', f).find((r) => r.value === fallback.options[j]);
              if (radio) radio.checked = true;
            });
            sel = selection();
          }
        }
        current = find(sel);
        updateOptionStates(sel);
        render(current);
      });
    });
    updateOptionStates(selection());

    // Cantidad
    const clampQty = (n) => Math.min(99, Math.max(1, Number.parseInt(n, 10) || 1));
    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-qty-minus]')) qtyInput.value = clampQty(Number(qtyInput.value) - 1);
      if (event.target.closest('[data-qty-plus]')) qtyInput.value = clampQty(Number(qtyInput.value) + 1);
    });
    qtyInput.addEventListener('change', () => { qtyInput.value = clampQty(qtyInput.value); });

    const submit = async () => {
      if (!current || !current.available || addBtn.disabled) return;
      addBtn.disabled = true;
      addLabel.textContent = 'Agregando…';
      if (stickyBtn) stickyBtn.disabled = true;
      try {
        await addToCart([{ id: current.id, quantity: clampQty(qtyInput.value) }]);
        qtyInput.value = 1;
      } catch (error) {
        if (errorBox) {
          errorBox.textContent = error.message;
          errorBox.hidden = false;
        }
        toast(error.message, 'error');
      } finally {
        render(current);
      }
    };
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      submit();
    });
    if (stickyBtn) stickyBtn.addEventListener('click', submit);

    // Barra fija en móvil cuando el botón principal sale de pantalla
    if (sticky && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', passed);
        sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = passed ? 0 : -1;
      });
      io.observe($('[data-buy]', form) || addBtn);
    }
  }

  /* ---------- Recomendaciones ---------- */
  function initRecommendations(el) {
    const load = async () => {
      try {
        const res = await fetch(el.dataset.url);
        if (!res.ok) throw new Error();
        const fresh = $('[data-recommendations]', parseHTML(await res.text()));
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          enhanceCatalog(el);
          observeReveals(el);
        } else {
          el.remove();
        }
      } catch (_) {
        el.remove();
      }
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          io.disconnect();
          load();
        }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(el);
    } else load();
  }

  /* ---------- Búsqueda instantánea ---------- */
  function initPredictiveSearch() {
    const panel = document.getElementById('SearchPanel');
    if (!panel) return;
    const input = $('[data-search-input]', panel);
    const form = $('[data-search-form]', panel);
    const results = $('[data-search-results]', panel);
    const idle = $('[data-search-idle]', panel);
    let controller = null;
    let timer = 0;

    const searchUrl = (q) =>
      (routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
    const escape = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const setContent = (html) => {
      $$(':scope > :not([data-search-idle])', results).forEach((n) => n.remove());
      idle.hidden = html !== null;
      if (html !== null) results.insertAdjacentHTML('beforeend', html);
    };

    const run = async (q) => {
      if (controller) controller.abort();
      controller = new AbortController();
      setContent(
        '<div aria-busy="true">' +
          '<div class="skeleton-row"><div class="skeleton"></div><div class="skeleton-lines"><div class="skeleton"></div><div class="skeleton"></div></div></div>'.repeat(3) +
          '</div>'
      );
      try {
        const params = new URLSearchParams({
          q,
          'resources[type]': 'product',
          'resources[limit]': '6',
          'resources[options][unavailable_products]': 'last',
          'resources[options][fields]': 'title,product_type,variants.title,vendor,tag',
        });
        const res = await fetch((routes.predictiveSearch || '/search/suggest') + '.json?' + params, { signal: controller.signal });
        if (!res.ok) throw new Error();
        const data = await res.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          setContent(
            '<div class="search-empty"><p class="display">No encontramos productos para tu búsqueda.</p><p class="text-muted mt-2">Probá con otro término.</p></div>'
          );
          return;
        }
        const items = products.map((p) => {
          const price = Math.round(parseFloat(p.price) * 100);
          const compare = Math.round(parseFloat(p.compare_at_price_max || 0) * 100);
          const img = (p.featured_image && p.featured_image.url) || p.image;
          const imgUrl = img ? img + (img.includes('?') ? '&' : '?') + 'width=120' : '';
          return (
            '<a class="suggestion" href="' + escape(p.url) + '">' +
            '<span class="suggestion__img">' + (imgUrl ? '<img src="' + escape(imgUrl) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</span>' +
            '<span class="suggestion__text"><span class="suggestion__title">' + escape(p.title) + '</span>' +
            '<span class="suggestion__meta">' + escape(p.vendor) + (p.available ? '' : ' · Agotado') + '</span></span>' +
            '<span class="suggestion__price"><span' + (compare > price ? ' class="text-brand"' : '') + '>' + escape(formatMoney(price)) + '</span>' +
            (compare > price ? '<s>' + escape(formatMoney(compare)) + '</s>' : '') + '</span></a>'
          );
        });
        setContent(
          items.join('') +
            '<a class="btn btn--dark btn--full mt-4" href="' + escape(searchUrl(q)) + '">Ver todos los resultados</a>'
        );
      } catch (error) {
        if (error.name === 'AbortError') return;
        setContent('<p class="search-empty text-muted">No pudimos buscar en este momento. Probá de nuevo.</p>');
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) {
        if (controller) controller.abort();
        setContent(null);
        return;
      }
      timer = setTimeout(() => run(q), 180);
    });
    form.addEventListener('submit', (event) => {
      const q = input.value.trim();
      if (!q) event.preventDefault();
    });
  }

  /* ---------- Catálogo: animaciones, columnas y "ver más" ---------- */
  let gridObserver = null;
  function animateGrid(root = document) {
    const items = $$('[data-grid] > li:not(.is-in)', root);
    // Índice dentro de cada tanda visible para escalonar la entrada
    items.forEach((li, i) => li.style.setProperty('--i', String(i % 8)));
    if (!('IntersectionObserver' in window) || reducedMotion()) {
      items.forEach((li) => li.classList.add('is-in'));
      return;
    }
    if (!gridObserver) {
      gridObserver = new IntersectionObserver((entries) => {
        let n = 0;
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.style.setProperty('--i', String(n++ % 8));
          entry.target.classList.add('is-in');
          gridObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    }
    items.forEach((li) => gridObserver.observe(li));
  }

  function markLoadedImages(root = document) {
    $$('.card__img--first:not(.is-loaded)', root).forEach((img) => {
      const done = () => img.classList.add('is-loaded');
      if (img.complete && img.naturalWidth > 0) done();
      else {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    });
  }

  const COLS_KEY = { m: 'rs-cols-m', d: 'rs-cols-d' };
  function readCols(kind, fallback) {
    try { return localStorage.getItem(COLS_KEY[kind]) || fallback; } catch (_) { return fallback; }
  }
  function applyCols(root = document) {
    const m = readCols('m', '2');
    const d = readCols('d', '3');
    $$('[data-grid]', root).forEach((grid) => {
      grid.dataset.colsM = m;
      grid.dataset.colsD = d;
    });
    $$('[data-cols-m]', root).forEach((b) => { if (b.tagName === 'BUTTON') b.setAttribute('aria-pressed', String(b.dataset.colsM === m)); });
    $$('[data-cols-d]', root).forEach((b) => { if (b.tagName === 'BUTTON') b.setAttribute('aria-pressed', String(b.dataset.colsD === d)); });
  }
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('button[data-cols-m], button[data-cols-d]');
    if (!btn) return;
    const kind = btn.dataset.colsM ? 'm' : 'd';
    try { localStorage.setItem(COLS_KEY[kind], btn.dataset.colsM || btn.dataset.colsD); } catch (_) { /* sin almacenamiento */ }
    applyCols();
  });

  function enhanceCatalog(root = document) {
    applyCols(root);
    markLoadedImages(root);
    animateGrid(root);
  }

  function showTopLoader(on) {
    let bar = $('.top-loader');
    if (on && !bar) {
      bar = document.createElement('div');
      bar.className = 'top-loader';
      document.body.appendChild(bar);
    } else if (!on && bar) bar.remove();
  }

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-load-more]');
    if (!btn) return;
    event.preventDefault();
    const root = $('[data-collection-root]');
    const grid = root && $('[data-grid]', root);
    if (!grid) {
      window.location.href = btn.href;
      return;
    }
    btn.classList.add('is-loading');
    try {
      const url = new URL(btn.href, window.location.origin);
      url.searchParams.set('section_id', root.dataset.sectionId);
      const res = await fetch(url.toString());
      if (!res.ok) throw new Error();
      const doc = parseHTML(await res.text());
      const items = $$('[data-grid] > li', doc);
      items.forEach((li) => grid.appendChild(li));
      const freshWrap = $('[data-load-more-wrap]', doc);
      const wrap = $('[data-load-more-wrap]', root);
      if (wrap && freshWrap) wrap.replaceWith(freshWrap);
      else if (wrap) wrap.remove();
      enhanceCatalog(grid.parentElement);
      const first = items[0] && items[0].querySelector('a[href]');
      if (first) first.focus({ preventScroll: true });
    } catch (_) {
      window.location.href = btn.href;
    }
  });

  /* ---------- Filtros y orden sin recargar ---------- */
  async function loadResults(url, push = true) {
    const root = $('[data-collection-root]');
    if (!root) {
      window.location.href = url;
      return;
    }
    const target = new URL(url, window.location.origin);
    const fetchUrl = new URL(target.toString());
    fetchUrl.searchParams.set('section_id', root.dataset.sectionId);
    const resultsEl = $('[data-results]', root);
    if (resultsEl) resultsEl.classList.add('is-loading');
    showTopLoader(true);
    try {
      const res = await fetch(fetchUrl.toString());
      if (!res.ok) throw new Error();
      const fresh = $('[data-collection-root]', parseHTML(await res.text()));
      if (!fresh) throw new Error();
      $$('dialog[open]', root).forEach((d) => d.close());
      const swap = () => {
        root.replaceWith(fresh);
        enhanceCatalog(fresh);
      };
      if (document.startViewTransition && !reducedMotion()) await document.startViewTransition(swap).updateCallbackDone;
      else swap();
      if (push) window.history.pushState({ facets: true }, '', target.pathname + target.search);
      observeReveals(fresh);
      const top = fresh.querySelector('.collection-layout');
      if (top && top.getBoundingClientRect().top < 0) {
        top.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
      }
    } catch (_) {
      window.location.href = target.toString();
    } finally {
      showTopLoader(false);
    }
  }

  function formToUrl(form) {
    const params = new URLSearchParams();
    for (const [key, value] of new FormData(form)) {
      if (String(value).trim() !== '') params.append(key, value);
    }
    return (form.getAttribute('action') || window.location.pathname) + '?' + params.toString();
  }

  document.addEventListener('change', (event) => {
    const sort = event.target.closest('[data-sort]');
    if (sort) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      loadResults(url.toString());
      return;
    }
    const form = event.target.closest('[data-facets-form][data-live]');
    if (form && event.target.type === 'checkbox') loadResults(formToUrl(form));
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-facets-form]');
    if (!form) return;
    event.preventDefault();
    loadResults(formToUrl(form));
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-facet-link]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    loadResults(link.href);
  });

  window.addEventListener('popstate', () => {
    if ($('[data-collection-root]')) loadResults(window.location.href, false);
  });

  /* ---------- Buscá por tu moto ---------- */
  function initMotoFinder(form) {
    const dataEl = $('[data-moto-data]', form);
    const brandSel = $('[data-moto-brand]', form);
    const modelSel = $('[data-moto-model]', form);
    if (!dataEl || !brandSel || !modelSel || form.dataset.ready) return;
    form.dataset.ready = '1';
    let items = [];
    try { items = JSON.parse(dataEl.textContent); } catch (_) { return; }
    const byBrand = new Map();
    items.forEach(({ label, handle }) => {
      const [brand, ...rest] = String(label).trim().split(/\s+/);
      if (!brand) return;
      const model = rest.join(' ') || brand;
      if (!byBrand.has(brand)) byBrand.set(brand, []);
      byBrand.get(brand).push({ model, handle });
    });
    [...byBrand.keys()].sort((a, b) => a.localeCompare(b, 'es')).forEach((brand) => {
      brandSel.add(new Option(brand, brand));
    });
    brandSel.addEventListener('change', () => {
      modelSel.length = 1;
      const models = byBrand.get(brandSel.value) || [];
      models
        .sort((a, b) => a.model.localeCompare(b.model, 'es', { numeric: true }))
        .forEach(({ model, handle }) => modelSel.add(new Option(model, handle)));
      modelSel.disabled = models.length === 0;
      if (models.length === 1) modelSel.selectedIndex = 1;
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!modelSel.value) {
        (brandSel.value ? modelSel : brandSel).focus();
        return;
      }
      const base = (form.dataset.baseUrl || '/collections/all').replace(/\/$/, '');
      window.location.href = base + '/' + encodeURIComponent(modelSel.value);
    });
  }

  /* ---------- Visor de fotos con zoom ---------- */
  function initLightbox(root, gallery) {
    const dialog = $('[data-lightbox]', root);
    const galleryTrack = $('[data-gallery-track]', root);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const track = $('[data-lightbox-track]', dialog);
    const slides = $$('.lightbox__slide', track);
    const counter = $('[data-lightbox-index]', dialog);
    const hint = $('[data-lightbox-hint]', dialog);
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    let index = 0;
    let zoomed = null;

    const clamp = (i) => Math.max(0, Math.min(slides.length - 1, i));
    const unzoom = () => {
      if (!zoomed) return;
      const img = $('img', zoomed);
      if (img) img.style.width = '';
      zoomed.classList.remove('is-zoomed');
      track.classList.remove('is-zoomed');
      zoomed = null;
    };
    const goTo = (i, smooth = true) => {
      unzoom();
      index = clamp(i);
      track.scrollTo({ left: track.clientWidth * index, behavior: smooth && !reducedMotion() ? 'smooth' : 'auto' });
      if (counter) counter.textContent = String(index + 1);
    };
    const panTo = (slide, x, y) => {
      const r = slide.getBoundingClientRect();
      const fx = Math.max(0, Math.min(1, (x - r.left) / r.width));
      const fy = Math.max(0, Math.min(1, (y - r.top) / r.height));
      slide.scrollLeft = fx * (slide.scrollWidth - r.width);
      slide.scrollTop = fy * (slide.scrollHeight - r.height);
    };
    const zoomAt = (slide, x, y) => {
      const img = $('img', slide);
      if (!img) return;
      const base = img.getBoundingClientRect().width;
      img.style.width = Math.round(base * 2.5) + 'px';
      slide.classList.add('is-zoomed');
      track.classList.add('is-zoomed');
      zoomed = slide;
      if (hint) hint.hidden = true;
      panTo(slide, x, y);
    };

    slides.forEach((slide) => {
      slide.addEventListener('click', (event) => {
        if (slide.classList.contains('is-zoomed')) unzoom();
        else zoomAt(slide, event.clientX, event.clientY);
      });
      if (finePointer) {
        slide.addEventListener('mousemove', (event) => {
          if (slide.classList.contains('is-zoomed')) panTo(slide, event.clientX, event.clientY);
        });
      }
    });
    track.addEventListener('scroll', () => {
      if (zoomed) return;
      index = clamp(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
      if (counter) counter.textContent = String(index + 1);
    }, { passive: true });
    const prev = $('[data-lightbox-prev]', dialog);
    const next = $('[data-lightbox-next]', dialog);
    if (prev) prev.addEventListener('click', () => goTo(index - 1));
    if (next) next.addEventListener('click', () => goTo(index + 1));
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') goTo(index + 1);
      if (event.key === 'ArrowLeft') goTo(index - 1);
    });

    const open = () => {
      const start = galleryTrack ? Math.round(galleryTrack.scrollLeft / Math.max(1, galleryTrack.clientWidth)) : 0;
      if (hint) hint.hidden = false;
      dialog.showModal();
      goTo(start, false);
    };
    $$('[data-open-lightbox]', root).forEach((btn) => btn.addEventListener('click', open));
    if (galleryTrack) {
      galleryTrack.addEventListener('click', (event) => {
        if (event.target.closest('.gallery__slide img')) open();
      });
    }
    dialog.addEventListener('close', () => {
      unzoom();
      const slide = slides[index];
      if (gallery && slide) gallery.showMedia(slide.dataset.mediaId);
    });
  }

  /* ---------- Vistos recientemente ---------- */
  const RECENT_KEY = 'rs-recent';
  function readRecent() {
    try {
      const list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string' && h) : [];
    } catch (_) {
      return [];
    }
  }
  function writeRecent(list) {
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12))); } catch (_) { /* sin almacenamiento */ }
  }
  function rememberProduct(handle) {
    if (!handle) return;
    writeRecent([handle, ...readRecent().filter((h) => h !== handle)]);
  }
  async function initRecentlyViewed(section) {
    const list = $('[data-recent-list]', section);
    if (!list || list.dataset.loaded) return;
    list.dataset.loaded = 'true';
    const current = section.dataset.current;
    const limit = Number(section.dataset.limit) || 4;
    const handles = readRecent().filter((h) => h !== current).slice(0, limit);
    if (!handles.length) return;
    const base = (routes.root || '/').replace(/\/?$/, '/');
    const gone = [];
    const cards = await Promise.all(handles.map(async (handle) => {
      try {
        const res = await fetch(base + 'products/' + encodeURIComponent(handle) + '?section_id=card-ajax');
        if (res.status === 404) gone.push(handle);
        if (!res.ok) return null;
        return $('.card', parseHTML(await res.text()));
      } catch (_) {
        return null;
      }
    }));
    if (gone.length) writeRecent(readRecent().filter((h) => !gone.includes(h)));
    const found = cards.filter(Boolean);
    if (!found.length) return;
    found.forEach((card) => {
      const li = document.createElement('li');
      li.appendChild(document.importNode(card, true));
      list.appendChild(li);
    });
    section.hidden = false;
    enhanceCatalog(section);
  }

  /* ---------- Compatible con: ver todas ---------- */
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-compat-more]');
    if (!btn) return;
    const box = btn.closest('.compat');
    if (box) box.classList.add('is-open');
    btn.remove();
  });

  /* ---------- Popup de bienvenida ---------- */
  const WELCOME_KEY = 'rs-welcome';
  function initWelcome() {
    const dialog = $('[data-welcome]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const read = () => {
      try { return JSON.parse(localStorage.getItem(WELCOME_KEY) || 'null'); } catch (_) { return null; }
    };
    const save = (state) => {
      try { localStorage.setItem(WELCOME_KEY, JSON.stringify({ state, at: Date.now() })); } catch (_) { /* sin almacenamiento */ }
    };
    let fromPopup = false;
    try {
      fromPopup = sessionStorage.getItem('rs-welcome-sent') === '1';
      sessionStorage.removeItem('rs-welcome-sent');
    } catch (_) { /* sin almacenamiento */ }

    const form = $('[data-welcome-form]', dialog);
    if (form) {
      form.addEventListener('submit', () => {
        try { sessionStorage.setItem('rs-welcome-sent', '1'); } catch (_) { /* sin almacenamiento */ }
      });
    }

    // Volvió de suscribirse (desde el popup o desde el bloque del inicio)
    if ($('[data-welcome-posted]', dialog)) {
      save('subscribed');
      if (fromPopup) dialog.showModal();
      return;
    }
    if (fromPopup && $('[data-welcome-error]', dialog)) {
      dialog.showModal();
      return;
    }

    const saved = read();
    const days = Number(dialog.dataset.days) || 14;
    if (saved && (saved.state === 'subscribed' || Date.now() - saved.at < days * 86400000)) return;

    let timer = 0;
    const onLeave = (event) => {
      if (!event.relatedTarget && event.clientY <= 0) show();
    };
    function show() {
      // No interrumpir si hay otro panel abierto (carrito, búsqueda…)
      if ($('dialog[open]')) {
        clearTimeout(timer);
        timer = setTimeout(show, 6000);
        return;
      }
      clearTimeout(timer);
      document.removeEventListener('mouseout', onLeave);
      save('seen');
      dialog.showModal();
    }
    timer = setTimeout(show, (Number(dialog.dataset.delay) || 8) * 1000);
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      setTimeout(() => document.addEventListener('mouseout', onLeave), 4000);
    }
  }

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-copy-code]');
    if (!btn) return;
    const codeEl = $('[data-welcome-code]', btn.parentElement);
    const code = codeEl ? codeEl.textContent.trim() : '';
    try {
      await navigator.clipboard.writeText(code);
      btn.textContent = '¡Copiado!';
    } catch (_) {
      if (codeEl) window.getSelection().selectAllChildren(codeEl);
    }
  });

  /* ---------- Fotos de tarjetas: mostrarlas al cargar (también las que llegan después) ---------- */
  ['load', 'error'].forEach((type) => {
    document.addEventListener(type, (event) => {
      const img = event.target;
      if (img && img.classList && img.classList.contains('card__img--first')) img.classList.add('is-loaded');
    }, true);
  });

  /* ---------- Códigos de descuento en el carrito ---------- */
  function currentCodes(root) {
    try {
      const el = $('[data-cart-codes]', root);
      const list = el ? JSON.parse(el.textContent) : [];
      return Array.isArray(list) ? list : [];
    } catch (_) {
      return [];
    }
  }
  async function updateDiscounts(codes) {
    const res = await fetch((routes.cart || '/cart') + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(','), sections: cartSectionIds(), sections_url: window.location.pathname }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'No pudimos actualizar el código.');
    renderCartSections(data.sections);
    return data;
  }
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-cart-discount]');
    if (!form) return;
    event.preventDefault();
    const input = $('input[name="discount"]', form);
    const code = input ? input.value.trim() : '';
    if (!code) {
      if (input) input.focus();
      return;
    }
    const codes = currentCodes(form.closest('.cart-summary') || document);
    if (codes.some((c) => c.toLowerCase() === code.toLowerCase())) {
      toast('Ese código ya está aplicado.');
      return;
    }
    const btn = $('button[type="submit"]', form);
    if (btn) btn.classList.add('is-loading');
    try {
      const data = await updateDiscounts([...codes, code]);
      if (!Array.isArray(data.discount_codes)) {
        // Tienda sin soporte para códigos en el carrito: se aplican con el enlace estándar
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(routes.cart || '/cart');
        return;
      }
      const found = data.discount_codes.find((d) => String(d.code).toLowerCase() === code.toLowerCase());
      if (found && found.applicable) toast('¡Listo! Código ' + found.code + ' aplicado.');
      else if (found) toast('El código ' + found.code + ' no aplica a este carrito.', 'error');
      else toast('No encontramos ese código. Revisalo e intentá de nuevo.', 'error');
    } catch (error) {
      toast(error.message, 'error');
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  });
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-remove-discount]');
    if (!btn) return;
    const code = btn.dataset.removeDiscount;
    const codes = currentCodes(btn.closest('.cart-summary') || document).filter((c) => c.toLowerCase() !== code.toLowerCase());
    btn.disabled = true;
    try {
      await updateDiscounts(codes);
      toast('Código quitado.');
    } catch (error) {
      toast(error.message, 'error');
      btn.disabled = false;
    }
  });

  /* ---------- Luz que sigue al mouse en tarjetas destacadas ---------- */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('pointermove', (event) => {
      const card = event.target.closest && event.target.closest('[data-spotlight]');
      if (!card) return;
      const r = card.getBoundingClientRect();
      card.style.setProperty('--mx', (event.clientX - r.left) + 'px');
      card.style.setProperty('--my', (event.clientY - r.top) + 'px');
    }, { passive: true });
  }

  /* ---------- Encabezado con sombra al bajar ---------- */
  function initHeaderScroll() {
    const header = $('.section-header');
    if (!header) return;
    let ticking = false;
    const update = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }

  /* ---------- Globito de WhatsApp (una vez por visita) ---------- */
  function initWhatsAppBubble() {
    const root = $('[data-wa]');
    const bubble = root && $('[data-wa-bubble]', root);
    if (!bubble) return;
    let seen = false;
    try { seen = sessionStorage.getItem('rs-wa-bubble') === '1'; } catch (_) { /* sin almacenamiento */ }
    if (seen) return;
    const hide = () => {
      bubble.classList.remove('is-visible');
      setTimeout(() => { bubble.hidden = true; }, 250);
      try { sessionStorage.setItem('rs-wa-bubble', '1'); } catch (_) { /* sin almacenamiento */ }
    };
    setTimeout(() => {
      // No aparece encima de un panel abierto (carrito, popup, búsqueda)
      if ($('dialog[open]')) return;
      bubble.hidden = false;
      requestAnimationFrame(() => bubble.classList.add('is-visible'));
      setTimeout(hide, 9000);
    }, 12000);
    $('[data-wa-close]', root).addEventListener('click', hide);
    $('.wa-float', root).addEventListener('click', hide);
  }

  /* ---------- Reseñas: "leer más", "ver todas", visor de fotos y formulario ---------- */
  function initReviews(root) {
    // "Leer más" solo en los textos que quedaron cortados
    $$('[data-review-card]', root).forEach((card) => {
      const text = $('[data-review-text]', card);
      const more = $('[data-review-more]', card);
      if (!text || !more || card.classList.contains('is-hidden')) return;
      more.hidden = text.scrollHeight <= text.clientHeight + 2;
    });

    // Volvió de enviar una opinión: reabrir el panel con el mensaje de gracias (o el error)
    let fromReview = false;
    try {
      fromReview = sessionStorage.getItem('rs-review-sent') === '1';
      if (fromReview) sessionStorage.removeItem('rs-review-sent');
    } catch (_) { /* sin almacenamiento */ }
    $$('[data-review-dialog]', root).forEach((dialog) => {
      const form = $('[data-review-form]', dialog);
      if (form) {
        form.addEventListener('submit', () => {
          try { sessionStorage.setItem('rs-review-sent', '1'); } catch (_) { /* sin almacenamiento */ }
        });
      }
      if (fromReview && ($('[data-review-posted]', dialog) || $('[data-review-error]', dialog)) && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    });
  }

  document.addEventListener('click', (event) => {
    const more = event.target.closest('[data-review-more]');
    if (more) {
      const card = more.closest('[data-review-card]');
      if (card) card.classList.add('is-expanded');
      more.hidden = true;
      return;
    }
    const all = event.target.closest('[data-reviews-more]');
    if (all) {
      const section = all.closest('[data-reviews]');
      $$('[data-review-card].is-hidden', section).forEach((card, i) => {
        card.classList.remove('is-hidden');
        card.style.animationDelay = (i % 6) * 60 + 'ms';
        card.classList.add('is-revealed');
      });
      initReviews(section);
      all.closest('.reviews__more').remove();
      return;
    }
    const photo = event.target.closest('[data-review-photo]');
    if (photo) {
      const section = photo.closest('[data-reviews]');
      const viewer = section && $('[data-review-viewer]', section);
      if (!viewer || typeof viewer.showModal !== 'function') {
        window.open(photo.dataset.reviewPhoto, '_blank', 'noopener');
        return;
      }
      const group = $$('[data-review-photo]', section).filter((b) => b.dataset.reviewGroup === photo.dataset.reviewGroup);
      let index = group.indexOf(photo);
      const img = $('[data-viewer-img]', viewer);
      const counter = $('[data-viewer-index]', viewer);
      const totalEl = $('[data-viewer-total]', viewer);
      const prev = $('[data-viewer-prev]', viewer);
      const next = $('[data-viewer-next]', viewer);
      const show = (i) => {
        index = (i + group.length) % group.length;
        img.src = group[index].dataset.reviewPhoto;
        if (counter) counter.textContent = String(index + 1);
      };
      if (totalEl) totalEl.textContent = String(group.length);
      if (prev) prev.hidden = group.length < 2;
      if (next) next.hidden = group.length < 2;
      viewer.onkeydown = (e) => {
        if (e.key === 'ArrowRight') show(index + 1);
        if (e.key === 'ArrowLeft') show(index - 1);
      };
      if (prev) prev.onclick = () => show(index - 1);
      if (next) next.onclick = () => show(index + 1);
      show(index);
      viewer.showModal();
    }
  });

  /* ---------- Seguimiento: copia el código y abre la página del correo ---------- */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-track-form]');
    if (!form) return;
    event.preventDefault();
    const input = $('input', form);
    const code = input ? input.value.trim() : '';
    if (!code) {
      if (input) input.focus();
      return;
    }
    // Copiar mientras la página tiene el foco y abrir en el mismo clic (si no, el navegador lo bloquea)
    const copying = navigator.clipboard && navigator.clipboard.writeText
      ? navigator.clipboard.writeText(code).catch(() => {})
      : Promise.resolve();
    const win = window.open(form.dataset.url, '_blank');
    if (win) {
      try { win.opener = null; } catch (_) { /* otra pestaña */ }
    }
    await copying;
    const hint = $('[data-track-hint]', form.parentElement);
    if (hint) hint.hidden = false;
    if (!win) window.location.href = form.dataset.url;
  });

  /* ---------- Pie de página: columnas desplegables en celular ---------- */
  function initFooterColumns() {
    const cols = $$('.footer-col');
    if (!cols.length) return;
    const mq = window.matchMedia('(max-width: 767px)');
    const apply = () => cols.forEach((col) => { col.open = !mq.matches; });
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }

  /* ---------- Reseñas en carrusel ---------- */
  function initReviewCarousels(root) {
    $$('[data-reviews-carousel]', root).forEach((wrap) => {
      const track = $('[data-reviews-track]', wrap);
      const nav = $('[data-reviews-nav]', wrap);
      if (!track || !nav || wrap.dataset.ready) return;
      wrap.dataset.ready = 'true';
      const cards = $$('[data-review-card]', track);
      const prev = $('[data-reviews-prev]', nav);
      const next = $('[data-reviews-next]', nav);
      const pos = $('[data-reviews-pos]', nav);
      const step = () => (cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth);
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        nav.hidden = max <= 0;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
        if (pos) pos.textContent = String(Math.min(cards.length, Math.round(track.scrollLeft / Math.max(1, step())) + 1));
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reducedMotion() ? 'auto' : 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reducedMotion() ? 'auto' : 'smooth' }));
      let frame = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  /* ---------- Portada: profundidad al bajar ---------- */
  function initHeroDepth() {
    const media = $('.hero__media');
    if (!media || reducedMotion()) return;
    let ticking = false;
    const update = () => {
      const y = Math.min(window.scrollY, window.innerHeight);
      media.style.setProperty('--hero-shift', (y * 0.25).toFixed(1) + 'px');
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  }

  /* ---------- Aparición al hacer scroll ---------- */
  let revealObserver = null;
  function observeReveals(root = document) {
    const items = $$('.reveal:not(.is-visible)', root);
    if (!('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    items.forEach((el) => revealObserver.observe(el));
  }

  /* ---------- Inicio ---------- */
  // Si una parte falla, el resto sigue funcionando y nada queda invisible
  function safe(fn) {
    try {
      fn();
    } catch (error) {
      document.documentElement.classList.add('no-anim');
      if (window.console) console.error('[Rider Shop]', error);
    }
  }

  function init() {
    safe(() => observeReveals());
    safe(() => enhanceCatalog());
    safe(() => $$('[data-product]').forEach(initProduct));
    safe(() => $$('[data-recommendations]').forEach(initRecommendations));
    safe(() => $$('[data-recently-viewed]').forEach(initRecentlyViewed));
    safe(() => $$('[data-moto-finder]').forEach(initMotoFinder));
    safe(initPredictiveSearch);
    safe(initWelcome);
    safe(initHeaderScroll);
    safe(initHeroDepth);
    safe(initWhatsAppBubble);
    safe(() => initReviews(document));
    safe(() => initReviewCarousels(document));
    safe(initFooterColumns);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Editor de temas: reinicializar secciones al editarlas
  document.addEventListener('shopify:section:load', (event) => {
    const el = event.target;
    safe(() => observeReveals(el));
    safe(() => enhanceCatalog(el));
    safe(() => $$('[data-product]', el).forEach(initProduct));
    safe(() => $$('[data-recommendations]', el).forEach(initRecommendations));
    safe(() => $$('[data-recently-viewed]', el).forEach(initRecentlyViewed));
    safe(() => $$('[data-moto-finder]', el).forEach(initMotoFinder));
    safe(() => initReviews(el));
    safe(() => initReviewCarousels(el));
  });

  window.RiderShop = { formatMoney, toast, addToCart };
})();
